import ContentLoader from 'react-content-loader';

const Skeleton = ({ className, width = '100%', height = '100%' }) => (
  <ContentLoader className={className} height={height} width={width} speed={2}>
    <rect x="0" y="0" rx="5" ry="5" width={width} height={height} />
  </ContentLoader>
);

export default Skeleton;
